/*
 *
 * Copyright © 2025 - 2026 Ping Identity Corporation. All right reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 *
 */
/**
 * @async
 * @function protect - returns a set of methods to interact with the PingOne Signals SDK
 * @param {ProtectConfig | SignalsInitializationOptions} options - the configuration options for the PingOne Signals SDK
 * @returns {Promise<Protect>} - a set of methods to interact with the PingOne Signals SDK
 */
export function protect(options) {
    let protectApiInitialized = false;
    return {
        start: async () => {
            try {
                /*
                 * Load the Ping Signals SDK
                 * this automatically pollutes the window
                 * there are no exports of this module
                 */
                await import('./signals-sdk.js');
                protectApiInitialized = true;
            }
            catch (err) {
                console.error('error loading ping signals', err);
                return { error: 'Failed to load PingOne Signals SDK' };
            }
            try {
                await window._pingOneSignals.init(options);
                if (options.behavioralDataCollection === true ||
                    options.behavioralDataCollection === 'true') {
                    window._pingOneSignals.resumeBehavioralData();
                }
            }
            catch (err) {
                console.error('error initializing ping protect', err);
                return { error: 'Failed to initialize PingOne Signals SDK' };
            }
        },
        getData: async () => {
            if (!protectApiInitialized) {
                return { error: 'PingOne Signals SDK is not initialized' };
            }
            try {
                return await window._pingOneSignals.getData();
            }
            catch (err) {
                console.error('error getting data from ping protect', err);
                return { error: 'Failed to get data from Protect' };
            }
        },
        pauseBehavioralData: () => {
            if (!protectApiInitialized) {
                return { error: 'PingOne Signals SDK is not initialized' };
            }
            try {
                window._pingOneSignals.pauseBehavioralData();
            }
            catch (err) {
                console.error('error pausing behavioral data in ping protect', err);
                return { error: 'Failed to pause behavioral data in Protect' };
            }
        },
        resumeBehavioralData: () => {
            if (!protectApiInitialized) {
                return { error: 'PingOne Signals SDK is not initialized' };
            }
            try {
                window._pingOneSignals.resumeBehavioralData();
            }
            catch (err) {
                console.error('error resuming behavioral data in ping protect', err);
                return { error: 'Failed to resume behavioral data in Protect' };
            }
        },
    };
}
//# sourceMappingURL=protect.js.map